import schedule from 'node-schedule';

export const schedulePageRefresh = (): void => {
    // Schedule the job to run at 1 AM, 3 AM, 5 AM, and 7 AM
    schedule.scheduleJob('0 1,3,5,7 * * *', () => {
      console.log('Refreshing the page at 1, 3, 5, or 7 AM');
      window.location.reload();
    });
  };